/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "scan_planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface WideBaselineRangeInfo {
  waypointIndex: number;
  stereoPairIndex: number;
}

function createBaseWideBaselineRangeInfo(): WideBaselineRangeInfo {
  return { waypointIndex: 0, stereoPairIndex: 0 };
}

export const WideBaselineRangeInfo = {
  encode(message: WideBaselineRangeInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.waypointIndex !== 0) {
      writer.uint32(8).sint64(message.waypointIndex);
    }
    if (message.stereoPairIndex !== 0) {
      writer.uint32(16).sint64(message.stereoPairIndex);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WideBaselineRangeInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWideBaselineRangeInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.waypointIndex = longToNumber(reader.sint64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.stereoPairIndex = longToNumber(reader.sint64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WideBaselineRangeInfo {
    return {
      waypointIndex: isSet(object.waypointIndex) ? globalThis.Number(object.waypointIndex) : 0,
      stereoPairIndex: isSet(object.stereoPairIndex) ? globalThis.Number(object.stereoPairIndex) : 0,
    };
  },

  toJSON(message: WideBaselineRangeInfo): unknown {
    const obj: any = {};
    if (message.waypointIndex !== 0) {
      obj.waypointIndex = Math.round(message.waypointIndex);
    }
    if (message.stereoPairIndex !== 0) {
      obj.stereoPairIndex = Math.round(message.stereoPairIndex);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WideBaselineRangeInfo>, I>>(base?: I): WideBaselineRangeInfo {
    return WideBaselineRangeInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WideBaselineRangeInfo>, I>>(object: I): WideBaselineRangeInfo {
    const message = createBaseWideBaselineRangeInfo();
    message.waypointIndex = object.waypointIndex ?? 0;
    message.stereoPairIndex = object.stereoPairIndex ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
